import axios from "axios";
import { debounce } from "mabiki";

export default {
  methods: {
    async getAccessoryItem(code) {
      const accessory = await axios.post(
        process.env.VUE_APP_LIT_REST_ROUTE +
          "/wp-json/litec/v2/accessory_item/",
        {
          code: code.code,
          remake: code.remake,
        }
      );
      return accessory.data;
    },

    /**
     * REST−DATAの遅延取得処理
     *
     */
    delayUpdateBtoResult: debounce(function () {
      this.update_bto_result({
        jewelleryItemId: this.jewelleryItemId,
        itemCode: this.jewelleryItemCode,
        designId: this.designId,
      });
    }, 1000),
  },
};
